import { render, staticRenderFns } from "./ChangeSecretPhone.vue?vue&type=template&id=ddf319d0&"
import script from "./ChangeSecretPhone.vue?vue&type=script&lang=js&"
export * from "./ChangeSecretPhone.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSecretPhone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports